namespace Roodik.Core
{
	export class AnalyticsManager implements IAnalytics
	{
		private _impl : GoogleImpl;
		
		constructor(private _appKey:string)
		{
			this.createImplementation();
		}
		
		private createImplementation()
		{
			this._impl = new GoogleImpl(this._appKey);
		}
		
		public sendPageview(eventName, value ?: number)
		{
			/*let params = {
				category:"1",//version
				action:eventName,
				label:"find-difference-bunny",
				value:value == null ? 1 : value
			}
			
			this._impl.sendPageview(eventName, params);*/
		};
		
		public sendEvent (eventCategory:string, eventAction:string, eventLabel:string, eventValue:number = 1, dimensions:Object = null)
		{
			this._impl.sendEvent(eventCategory, eventAction, eventLabel, eventValue, dimensions);
		};
		
		/*public sendEvent(eventName, value ?: number)
		{
			/!*let params = {
				category:"1",//version
				action:eventName,//action name
				label:"find-difference-bunny",//game name
				value:value == null ? 1 : value
			}
			this._impl.sendEvent(eventName, params);*!/
		};*/
		
	}
}



// WEBPACK FOOTER //
// /source/src/typescript/Core/Analytics/AnalyticsManager.ts